import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutionsSection } from './components/FailedSolutionsSection';
import { SolutionSection } from './components/SolutionSection';
import { TransformationSection } from './components/TransformationSection';
import { ForYouSection } from './components/ForYouSection';
import { IncludesSection } from './components/IncludesSection';
import { PricingCTA } from './components/PricingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen w-full bg-[#FDF8F0] overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <FailedSolutionsSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <TransformationSection data-id="element-5" />
      <ForYouSection data-id="element-6" />
      <IncludesSection data-id="element-7" />
      <PricingCTA data-id="element-8" />
      <Footer data-id="element-9" />
    </main>;
}